import { createDecorator } from 'vue-class-component';
import invoke from 'lodash/invoke';

export default function makeDecorator(duration) {
   return createDecorator(function _decorator(options, key) {
      const origin = options.methods[key];

      let res = null;
      let expired = _now() - duration;

      options.methods[key] = function _decoratorWrapper(...args) {
         const now = _now();
         if ( now > expired ) {
            res = origin.apply(this, args);
            expired = now + duration;
         }
         return res;
      };
   });
}

function _now() {
   return invoke(performance, 'now') || Date.now();
}
